module.exports = __webpack_public_path__ + "img/count-02.f68d44ee.png";